export default __webpack_public_path__ + "static/media/heart-of-steel-schlock.d25e1fd6.mp4";